import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonPage, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { alarmOutline, arrowBack, card, cubeOutline, informationCircleOutline, locationOutline, navigateOutline, person, personOutline, phonePortraitOutline, swapHorizontalOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { urlBase } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./AgendamentosDetalhes.css";
import maps from './imgs/maps.png';
import waze from './imgs/waze.png';

type IconType = typeof import('ionicons/icons/index');


type Props = {
  agendamentoid: string;
  onDismiss: () => void;
};

const AgendamentosDetalhes: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [dadosAgendamento, setDadosAgendamento] = useState<any>([]);
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {

    setEsconderMenu(true);

  });

  let params: any = {
    agendamentoid: ""
  }
  params = useParams();

  if (location && location.state && location.state.agendamentoid) {
    params.agendamentoid = location.state.agendamentoid;

  }


  if (props.agendamentoid) {
    params = {
      agendamentoid: props.agendamentoid
    }
  }

  function carregarAgendamento() {
    console.log("entrou", params.agendamentoid);
    if (params.agendamentoid != "" && params.agendamentoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);

        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") { token = tkn; }
        console.log("agendamentoid", params.agendamentoid);
        const getoperacao = async () => {

          setShowLoading(true);
          const resp = await fetch(urlBase.url + "/mobile/agendamento/" + params.agendamentoid.replaceAll(/#/g, '%23'),
            {
              method: urlBase.method,
              headers: [
                ["token", token],
                ["perfil", window.localStorage.getItem("perfil") || ""],
                ["marca", window.localStorage.getItem("marca") || ""],
              ],
              credentials: 'include'
            });
          const operacao = await resp.json();
          //if (resp.status === 400 || resp.status === 401) history.replace("/primeiroacesso/");
          if (operacao.Item !== undefined) {

            setDadosAgendamento(operacao.Item);
            console.log("dadosagendamento", operacao.Item);

          }

          setShowLoading(false);

        }

        getoperacao();
      }
    }
    return "";
  }

  function adicionaZeroNaData(numero: any) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  function formatarDataHora(data: Date) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + ("0" + data.getHours().toString()).substr(-2) + ":" + ("0" + data.getMinutes().toString()).substr(-2);
  }

  function formatarDataPeriodo(data: Date, periodo: string) {
    return adicionaZeroNaData(data.getDate().toString()) + "/" + (adicionaZeroNaData(data.getMonth() + 1).toString()) + " " + periodo;
  }

  function cpf_mask(v: string) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  const loadConvidados = () => {

    if ((!dadosAgendamento.convidados) || dadosAgendamento.convidados?.length == 0) {
      return (
        <IonItem lines="none" key={"semOperacao"}>

          <IonLabel className="ion-text-wrap">
            <h3>Não existe nenhum convidado</h3>
          </IonLabel>
        </IonItem>
      );
    }

    return dadosAgendamento.convidados?.map((value: any) => (

      <IonItem lines="none" key={"semOperacao"}>
        <IonIcon src={person} slot="start" />
        <IonLabel className="ion-text-wrap">
          <h3>{value.nome}</h3>
        </IonLabel>
      </IonItem>
    ))
  }

  return (

    <IonPage className="AgendamentosDetalhes">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <div>
            {carregarAgendamento()}
          </div>
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle className="ion-text-wrap" style={{ "padding-left": "20px", "padding-top": "0px", "padding-bottom": "0px", "text-align": "left" }}>Agenda</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>


        <div className="header">
          <div className="info">
            <IonIcon src={alarmOutline}></IonIcon>
            <div>
              <IonLabel>Agendado</IonLabel>
              <IonLabel>{dadosAgendamento ? (dadosAgendamento.parametroMostrarHorario ? formatarDataHora(new Date(dadosAgendamento.dataAgendamento)) : formatarDataPeriodo(new Date(dadosAgendamento.dataAgendamento), dadosAgendamento.periodoAgendamento)) : ""}</IonLabel>
            </div>
          </div>
        </div>
        <IonList>
          <IonListHeader lines="full">
            <IonLabel>Dados do agendamento</IonLabel>
          </IonListHeader>

          <IonItem lines="none" hidden={!(dadosAgendamento && dadosAgendamento.descricaoAgendamento)}>
            <IonIcon icon={cubeOutline} slot="start" />
            <div className="contentList">
              <h1>Descrição do agendamento</h1>
              <h2>{dadosAgendamento && dadosAgendamento.descricaoAgendamento ? dadosAgendamento.descricaoAgendamento : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon icon={swapHorizontalOutline} slot="start" />
            <div className="contentList">
              <h1>Tipo do agendamento</h1>
              <h2>{dadosAgendamento && dadosAgendamento.tipoAgendamento ? dadosAgendamento.tipoAgendamento : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon icon={informationCircleOutline} slot="start" />
            <div className="contentList">
              <h1>Status</h1>
              <h2>{dadosAgendamento ? dadosAgendamento.status : ""}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={locationOutline} slot="start" />
            <div className="contentList">
              <h1>Endereço</h1>
              <h2>{dadosAgendamento && dadosAgendamento.endereco ? [dadosAgendamento.endereco, dadosAgendamento.complemento]
                .filter(Boolean)
                .join(', ') : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={navigateOutline} slot="start" />
            <div className="contentList">

              {(dadosAgendamento && dadosAgendamento.enderecoLat && dadosAgendamento.enderecoLng) ? (
                <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                  <a target='_blank' href={"https://www.google.com/maps/search/?api=1&query=" + (dadosAgendamento ? dadosAgendamento.enderecoLat + "," + dadosAgendamento.enderecoLng + "&query_place_id=" : "")}><img src={maps} alt="maps" /></a>
                  <a target='_blank' href={"https://waze.com/ul?ll=" + (dadosAgendamento ? dadosAgendamento.enderecoLat + "%2C" + dadosAgendamento.enderecoLng : "") + "&navigate=yes"}><img src={waze} alt="waze" /></a>
                </div>
              ) : (
                <h2 style={{ color: "red" }}><b>Sem Localização</b></h2>
              )}

            </div>
          </IonItem>

          <IonListHeader lines="full">
            <IonLabel>Empresa</IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosAgendamento && dadosAgendamento.empresaNome ? dadosAgendamento.empresaNome : "não identificado"}</h2>
            </div>
          </IonItem>
          <IonItem lines="none">
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosAgendamento ? dadosAgendamento.empresaTelefone : "")}><h2>{dadosAgendamento && dadosAgendamento.empresaTelefone ? formataTelefone(dadosAgendamento.empresaTelefone) : "não identificado"}</h2></a>
              </div>
            </div>
          </IonItem>

          <IonListHeader lines="full" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonLabel>Cliente</IonLabel>
          </IonListHeader>
          <IonItem lines="none" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosAgendamento && dadosAgendamento.clienteNome ? dadosAgendamento.clienteNome : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none" hidden={window.localStorage.getItem("perfil") == "cliente" && localStorage.getItem("compartilhado") == "false"}>
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosAgendamento ? dadosAgendamento.clienteTelefone : "")}><h2>{dadosAgendamento && dadosAgendamento.clienteTelefone ? formataTelefone(dadosAgendamento.clienteTelefone) : "não identificado"}</h2></a>
              </div>
            </div>
          </IonItem>

          <IonListHeader lines="full">
            <IonLabel>Prestador</IonLabel>
          </IonListHeader>
          <IonItem lines="none">
            <IonIcon src={personOutline} slot="start" />
            <div className="contentList">
              <h1>Nome</h1>
              <h2>{dadosAgendamento && dadosAgendamento.prestadorNome ? dadosAgendamento.prestadorNome : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={card} slot="start" />
            <div className="contentList">
              <h1>CPF</h1>
              <h2>{dadosAgendamento && dadosAgendamento.prestadorCpf ? cpf_mask(dadosAgendamento.prestadorCpf) : "não identificado"}</h2>
            </div>
          </IonItem>

          <IonItem lines="none">
            <IonIcon src={phonePortraitOutline} slot="start" />
            <div className="contentList">
              <h1>Telefone</h1>
              <div style={{ paddingTop: "10px", display: "flex", columnGap: "20px", justifyContent: "left" }} >
                <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (dadosAgendamento ? dadosAgendamento.prestadorTelefone : "")}><h2>{dadosAgendamento && dadosAgendamento.prestadorTelefone ? formataTelefone(dadosAgendamento.prestadorTelefone) : "não identificado"}</h2></a>
              </div>
            </div>
          </IonItem>

          {dadosAgendamento.convidados && Array.isArray(dadosAgendamento.convidados) && dadosAgendamento.convidados.length > 0 && (
            <>
              <IonListHeader lines="full">
                <IonLabel>Convidados</IonLabel>
              </IonListHeader>

              {loadConvidados()}
            </>
          )}
        </IonList>

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>
    </IonPage>
  );


};

export default AgendamentosDetalhes;